<template>
  <v-app class="survey-container monitorSite">
    <NavBarAdmin></NavBarAdmin>

    <v-container fluid class="page-body p-4 pt-3 bg-light-blue admin-pageX">
      <v-layout data-app wrap>
        <router-view></router-view>
      </v-layout>
    </v-container>

    <FooterAdmin></FooterAdmin>
  </v-app>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "AdminContainer",
  data: () => ({}),
  methods: {},
  components: {
    AgGridVue
  }
};
</script>

<style scoped>
h1 {
  font-size: 18pt !important;
  font-weight: bold;
  font-style: italic;
}
a {
  font-weight: bold;
}
.content-left-top {
  padding: 0% 10% 5% 20%;
  text-align: left;
  /* font-family: Calibri(body), Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; */
}
.content-left-bottom {
  padding: 0% 0% 0% 25%;
  text-align: center;
  /* font-family: Calibri(body), Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; */
}
.sign-in-box {
  width: 80%;
}
.btn {
  width: 400px;
  margin: 0%;
  padding: 0%;
  color: white;
  font-weight: bold;
  font-size: 12pt;
  background-color: #3b9ee8 !important;
  width: fit-content;
  padding: 3% 5% 3% 5%;
  border-width: 1px;
  border-color: #ebf0f9 !important;
}
.btn:hover {
  color: #ffffff;
  border-color: #3b9ee8 !important;
}
.content-right {
  padding: 2% 10% 0% 5%;
  text-align: left;
  /* font-family: Calibri(body), Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; */
}
.content-box {
  background-color: #ececec;
  border: 1px solid #e0dede;
  padding: 2% 2% 1% 2%;
  margin-bottom: 2%;
  font-size: 9pt;
}
.tools {
  background-image: url(../assets/tools.png);
  background-size: 25px;
  background-repeat: no-repeat;
  margin: 5px 0 19px 0;
  padding: 2px 0 0 44px;
}
.data {
  background-image: url(../assets/data.png);
  background-size: 25px;
  background-repeat: no-repeat;
  margin: 5px 0 19px 0;
  padding: 2px 0 0 44px;
}
.materials {
  background-image: url(../assets/materials.png);
  background-size: 25px;
  background-repeat: no-repeat;
  margin: 5px 0 19px 0;
  padding: 2px 0 0 44px;
}
.list-lvl1 {
  margin-top: -2%;
  margin-left: 30px;
}
.list-lvl2 {
  margin-left: 25px;
}
.list-item {
  margin-bottom: 0px;
}
.top-gray {
  background-color: #e3e3e3;
  padding: 11px 0;
}
.main-title {
  color: #313b52;
  /* font-family: Georgia, Times New Roman, Times, serif; */
  font-size: 25px;
}
.sign-in-title-outer {
  padding-top: 60px;
}
.top-title-left-border {
  border-left: 1px solid #969696;
}
.sign-in-sub-title {
  /* font-family: Georgia, Time New Roman, Times, Serif; */
  color: #313b52;
  font-size: 21px;
  line-height: 40px;
  font-weight: bold;
  margin: 0 0 11px 0;
}
.sign-in-sub-title-right {
  /* font-family: Georgia, Time New Roman, Times, Serif; */
  color: #313b52;
  font-size: 40px;
  line-height: 59px;
  margin: 0 0 11px 0;
}
.blue-bar {
  background-color: #01bced;
  padding: 6px 0;
}
.blue-title-text {
  /* font-family: Georgia, Times, Times New Roman, san-serif; */
  color: #000000;
  font-size: 28px;
  font-weight: normal;
}
.blue-title-text a {
  color: #1b405a;
}
.blue-bar-title {
  text-align: center;
}
.content-space {
  padding: 49px 23px;
  /* font-family: Arial, Helvetica, san-serif; */
  font-size: 1em;
  line-height: 1.8125em;
  color: #5b5853;
}
.sub-titles-bold {
  font-size: 20px;
  font-weight: bold;
  display: block;
  margin-bottom: 11px;
}
.password-reset-space {
  padding-top: 23px;
  padding-left: 44px;
}
.password-reset-space a {
  color: #195d8d !important;
  font-size: 16px;
}
.about-title {
  /* font-family: Georgia, Times, Times New Roman, Serif; */
  color: #5b5853;
  font-size: 27px;
  line-height: 34px;
  font-weight: normal;
  background-image: url(../assets/icn-about.png);
  background-repeat: no-repeat;
  margin: 5px 0 19px 0;
  padding: 2px 0 0 44px;
}
/*Form Styles*/
.sign-in-form::placeholder {
  color: #595959;
}
.sign-in-form {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  height: 46px;
  padding: 0 11px;

  border: 1px solid #5fd5f4;
  border-radius: 0;
  color: #5b5853 !important;
}
.main-form-bttn {
  background-color: #313b52;
  color: #ffffff;
  padding: 17px 99px;
  border-radius: 0;
  border-bottom: 5px solid #01bced;
  font-size: 18px;
  font-weight: bold;
  border-top: 0;
  border-left: 0;
  border-right: 0;
}
.main-form-bttn:hover {
  background-color: #0e1b37;
  color: #ffffff;
  border-bottom: 5px solid #01bced;
}
.main-form-bttn:focus {
  background-color: #0e1b37;
  color: #ffffff;
  border-bottom: 5px solid #01bced;
}
.sign-button-left {
  width: 60%;
}
.sign-button-right {
  width: 40%;
  float: right;
}
.form-action {
  margin-left: -15px;
  margin-right: -15px;
}

/* STYLES FOR NSF DEFAULT */
.header-outter {
  width: 100%;
  background-color: #e3e3e3;
  height: 70px;
}
.header,
.feature {
  width: 1400px;
  margin: 0 auto;
}
.bottom {
  width: 1080px;
  margin: 32px auto;
}

/*CSS For Developer*/
.bottom-outter {
  width: 100%;
  background-color: #ffffff !important;
  margin-bottom: 80px;
}
html,
body {
  margin: 0;
  padding: 0;
  background-color: #ffffff !important;
}
.category-title-revised {
  /* font-family: Georgia, Times, Times New Roman, Serif !important; */
  color: #5b5853 !important;
  text-transform: none !important;
  font-size: 18px !important;
  font-weight: normal !important;
  padding-left: 9px !important;
  margin: 22px 0 9px 0 !important;
}
.q-revised {
  background-color: #d2d2d2 !important;
  padding: 5px 0 !important;
  border-radius: 4px !important;
}
.question-title {
  color: #000000 !important;
  font-size: 15px !important;
}
.Q .title:hover {
  background-color: #d2d2d2 !important;
}
#overall-status {
  border-top: #01bced 4px solid !important;
  padding: 15px !important;
  width: 97% !important;
}
#overall-status {
  border-left: #c4c4c4 1px solid !important;
}
#overall-status {
  border-right: #c4c4c4 1px solid !important;
}
#overall-status {
  border-bottom: #c4c4c4 1px solid !important;
}
#overall-status table th {
  border-left-color: #e98412 !important;
}
.not-ready {
  margin-top: 11px !important;
}
.status-content {
  width: 1080px;
  margin: 0 auto;
  padding-top: 0px;
  text-align: center;
}

/*CSS For Developer*/
.error {
  color: red;
  padding-bottom: 1em;
}
table tr td.lbl {
  padding: 0.7em 1em 0.7em 0;
}
table tr td.form_buttons {
  padding-top: 1em;
}
label {
  margin-bottom: 0 !important;
}
</style>
